import React from 'react';
import { URLS } from 'services/urls';
import './DirectSignUpPage.scss';

export const FeaturesSection = () => (
    <div className="DirectSignUp__Features">
        <img
            className="DirectSignUp__FeaturesImage"
            src={URLS.IMAGE_CLOUDFRONT_URL('deal/signup/building_side_image.png')}
            alt="Features Background"
        />
        <div className="DirectSignUp__FeatureWrapper">
            <div className="DirectSignUp__Feature">
                <img src={URLS.IMAGE_CLOUDFRONT_URL('deal/signup/manage.png')} alt="Manage" />
                <div>
                    <h4>Manage your deal pipeline</h4>
                    <p>Track, manage, and report on opportunities.</p>
                </div>
            </div>
        </div>
        <div className="DirectSignUp__FeatureWrapper">
            <div className="DirectSignUp__Feature">
                <img src={URLS.IMAGE_CLOUDFRONT_URL('deal/signup/assess.png')} alt="Assess" />
                <div>
                    <h4>Assess financial feasibility</h4>
                    <p>Evaluate quick, back-of-envelope scenarios for deals.</p>
                </div>
            </div>
        </div>
        <div className="DirectSignUp__FeatureWrapper">
            <div className="DirectSignUp__Feature">
                <img src={URLS.IMAGE_CLOUDFRONT_URL('deal/signup/underwrite.png')} alt="Underwrite" />
                <div>
                    <h4>Underwrite deals</h4>
                    <p>Model cash flows, returns, and profit distributions.</p>
                </div>
            </div>
        </div>
        <div className="DirectSignUp__FeatureWrapper">
            <div className="DirectSignUp__Feature">
                <img src={URLS.IMAGE_CLOUDFRONT_URL('deal/signup/managepartner.png')} alt="Manage Partner" />
                <div>
                    <h4>Manage partner relations</h4>
                    <p>Generate partner reports and automatically index deal-related communications.</p>
                </div>
            </div>
        </div>
    </div>
);

export default FeaturesSection;
